import { render, staticRenderFns } from "./Movable.vue?vue&type=template&id=3709ee8e&"
import script from "./Movable.vue?vue&type=script&lang=ts&"
export * from "./Movable.vue?vue&type=script&lang=ts&"
import style0 from "./Movable.vue?vue&type=style&index=0&id=3709ee8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports